import Vue from 'vue';
import storage from "../utils/storage";

export default {
  SET_LOGIN_MSG: (state, val) => {
    storage.setData('loginMsg', val)
    state.loginMsg = val
  },
  SET_CONFIG: (state, val) => {
    storage.setData('config', val)
    state.config = val
  },
  SET_MASK: (state, val) => {
    state.isMask = val
  },
  SET_DEVICE_CONFIG: (state, val) => {
    storage.setData('deviceConfig', val)
    state.deviceConfig = val
  },
  SET_CARNO: (state, val) => {
    storage.setData('carNo', val)
    state.carNo = val
  },
  SET_CURRENT_BILL: (state, val) => {
    storage.setData('currentBill', val)
    state.currentBill = val
  },
  SET_IDCARD_INFO: (state, val) => {
    storage.setData('idCardInfo', val)
    state.idCardInfo = val
  },
  SET_ICCARD: (state, val) => {
    storage.setData('icCard', val)
    state.icCard = val
  },
  SET_PRINT_MSG: (state, val) => {
    storage.setData('printMsg', val)
    state.printMsg = val
  },
  SET_CAR_MAIN_MSG: (state, val) => {
    storage.setData('carMainMsg', val)
    state.carMainMsg = val
  },
  SET_COST_MSG: (state, val) => {
    storage.setData('costMsg', val)
    state.costMsg = val
  },
  SET_COST_CHOOSE: (state, val) => {
    storage.setData('costChoose', val)
    state.costChoose = val
  },
  SET_PAY_LIST: (state, val) => {
    storage.setData('payList', val)
    state.payList = val
  },
  SET_FACE_IMG:(state, val) => {
    storage.setData('faceImg', val)
    state.faceImg = val
  },
  SET_SSeInfo:(state, {prop, val}) => {
    let data = val ? JSON.parse(val) : null;
    if (prop === 'thermometryCount' && (!data || !data.thermometryRespList || !data.thermometryRespList.length)) {
      let oldData = state.SSeInfo[prop];
      if (data) {
        data.thermometryRespList = oldData.thermometryRespList
      } else {
        data = {
          thermometryRespList: oldData.thermometryRespList
        }
      }
    }
    Vue.set(state.SSeInfo, prop, data);
    storage.setData('SSeInfo', state.SSeInfo);
  },
  DEL_SSeInfo:(state) => {
    let props = Object.keys(state.SSeInfo);
    props.map(prop => {
      Vue.set(state.SSeInfo, prop, null);
    });
    storage.setData('SSeInfo', state.SSeInfo);
  },
  setWarehouseFloor:(state, val) => {
    state.warehouseFloor = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js